import React from "react";

const ExpanderButton = ({ isExpanded, onToggle }) => (
  <button
    type="button"
    className="payment-plan-card__details-link"
    onClick={onToggle}
  >
    <span>
      {isExpanded ? "Hide Plan Details" : "View Plan Details"}
      <svg
        className={isExpanded ? "icon-arrow-up" : "icon-arrow-down"}
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <polyline points="6 9 12 15 18 9" />
      </svg>
    </span>
  </button>
);

export default ExpanderButton;
